import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DaypartsService } from 'app/siq-applications/modules/dayparts/services/dayparts.service';

@Injectable()
export class DaypartsCloneResolverService implements Resolve<void> {

  constructor(private daypartsService: DaypartsService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<void> | Promise<void> | void {
    this.daypartsService.cloneReport(route.paramMap.get('id'));
  }
}
